
import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import AOS from 'aos';
import LazyLoad from 'react-lazyload';
import slide1 from '../assets/images/banner/slide1.webp'
import slide2 from '../assets/images/banner/slide2.webp'
import slide3 from '../assets/images/banner/slide3.webp'

const Slider = () => {
    // const [loading, setLoading] = useState(true);
    // const [imagesLoaded, setImagesLoaded] = useState(0);

    // const imageSources = [
    //     require('../assets/images/banner/slide2.webp'),
    //     require('../assets/images/banner/slide1.webp'),
    // ];

    // useEffect(() => {
    //     if (imagesLoaded === imageSources.length) {
    //         setLoading(false);
    //     }
    // }, [imagesLoaded]);

    // const handleImageLoad = () => {
    //     setImagesLoaded(prevCount => prevCount + 1);
    // };

    // useEffect(() => {
    //     AOS.init();
    // }, [])
    return (
        <section>
            {/* {loading ? (
                <div className='skeleton-banner' >
                    <div className='skeleton-banner-img'></div>
                </div>
            ) : (
                <div style={{ background: "#fef8ef" }} >
                    <Carousel indicators={false} controls={true} fade>
                        {imageSources.map((src, index) => (
                            <Carousel.Item key={index} >
                                <LazyLoad offset={100}>
                                    <img
                                        loading="lazy"
                                        src={src}
                                        alt={`Slide ${index + 1}`}
                                        className="img-fluid"
                                    />
                                </LazyLoad>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            )}
            {imageSources.map((src, index) => (
                <img
                    key={index}
                    src={src}
                    alt={`Preload ${index + 1}`}
                    style={{ display: 'none' }}
                    onLoad={handleImageLoad}
                />

            ))} */}

            <Carousel fade>
                <Carousel.Item>
                    <img src={slide1} alt="" className='img-fluid' />
                </Carousel.Item>
                <Carousel.Item>
                    <img src={slide2} alt="" className='img-fluid' />
                </Carousel.Item>
                <Carousel.Item>
                    <img src={slide3} alt="" className='img-fluid' />
                </Carousel.Item>
            </Carousel>
        </section>
    );
};

export default Slider;